var _ = require('underscore');
module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="js-widget-container widget--popular-topics qa-widget-topics" style="display: none;">\n  <div class="widget__header">\n  </div>\n  <div class="widget__content">\n  </div>\n  <div class="widget__footer">\n  </div>\n</div>\n';
}
return __p;
};
